module.exports = "fonts/GilroySemiBold.woff";